(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initReveal = (root) => {
    const items = [...root.querySelectorAll('[data-elo18-reveal]')];
    root.classList.add('is-ready');

    if (!('IntersectionObserver' in window) || reducedMotion.matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.07, rootMargin: '0px 0px -8% 0px' },
    );

    items.forEach((item) => observer.observe(item));
  };

  const initAccordions = (root) => {
    root.querySelectorAll('[data-elo18-accordion]').forEach((accordion) => {
      const items = [...accordion.querySelectorAll(':scope > details')];
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  };

  const initFaqSearch = (root) => {
    const input = root.querySelector('[data-elo18-faq-search]');
    const clear = root.querySelector('[data-elo18-faq-clear]');
    const empty = root.querySelector('[data-elo18-faq-empty]');
    const categories = [...root.querySelectorAll('[data-elo18-faq-category]')];
    if (!input || !categories.length) return;

    const filter = () => {
      const query = input.value.trim().toLocaleLowerCase('bg');
      let totalMatches = 0;

      categories.forEach((category) => {
        const items = [...category.querySelectorAll('[data-elo18-faq-item]')];
        let categoryMatches = 0;

        items.forEach((item) => {
          const matches = !query || item.textContent.toLocaleLowerCase('bg').includes(query);
          item.hidden = !matches;
          if (!matches) item.open = false;
          if (matches) categoryMatches += 1;
        });

        category.hidden = categoryMatches === 0;
        totalMatches += categoryMatches;
      });

      if (empty) empty.hidden = totalMatches > 0;
      if (clear) clear.hidden = !query;
    };

    input.addEventListener('input', filter);
    clear?.addEventListener('click', () => {
      input.value = '';
      filter();
      input.focus();
    });
  };

  const init = (root) => {
    if (root.dataset.elo18Ready === 'true') return;
    root.dataset.elo18Ready = 'true';
    initReveal(root);
    initAccordions(root);
    initFaqSearch(root);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-elo18]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
